export default "__VITE_ASSET__CWISI2Ze__"